
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.164 5.945V4.852L6.07 2.789 6.672.953h.96l-.484 1.453 2.641-.922v1.172l-3.023.977-1.008 3.21 4.031 1.298v1.171L5.453 7.798l-.617 1.969h-.961l.71-2.274-4.42-1.547zm4.719.617l.812-2.585-4.422 1.421 3.61 1.165z","fill":"currentColor"}})])
          )
        }
      }
    